import "../../../../content/projects/wawelberg/wawelberg.css";
import * as React from 'react';
export default {
  React
};